import { render, staticRenderFns } from "./PlayerPowerInfoPage.vue?vue&type=template&id=b8b79856&scoped=true&"
import script from "./PlayerPowerInfoPage.vue?vue&type=script&lang=js&"
export * from "./PlayerPowerInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./PlayerPowerInfoPage.vue?vue&type=style&index=0&id=b8b79856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b79856",
  null
  
)

export default component.exports